export const SHOW_UPGRADE_CARD_MODAL = 'SHOW_UPGRADE_CARD_MODAL'
export const showUpgradeCardModal = (payload) => ({
  type: SHOW_UPGRADE_CARD_MODAL,
  payload
})

export const HIDE_UPGRADE_CARD_MODAL = 'HIDE_UPGRADE_CARD_MODAL'
export const hideUpgradeCardModal = (payload) => ({
  type: HIDE_UPGRADE_CARD_MODAL,
  payload
})

export const SHOW_PAYMENT_MODAL = 'SHOW_PAYMENT_MODAL'
export const setShowPaymentModal = (payload) => ({
  type: SHOW_PAYMENT_MODAL,
  payload
})

export const UPGRADE_QR_PAYLOAD = {
  title: 'Upgrade for QR Codes',
  desc: 'Easily share your link via a QR code that your visitors can scan with their phone.',
  gif: '/assets/img/gifs/qr.gif',
  cta: 'Download QR Code'
}

export const UPGRADE_CUSTOM_DOMAIN = {
  title: 'Upgrade to connect your own website domain',
  desc: 'Use your own brand and upload content to your own website domain',
  cta: 'Connect domain',
  gif: '/assets/img/gifs/custom-domain.gif'
}

export const UPGRADE_FEEDBACK_PAYLOAD = {
  title: 'Upgrade for Feedback Mode',
  desc: 'Allow visitors to comment on your work',
  gif: '/assets/img/gifs/feedback.gif',
  cta: 'Enable Comments'
}

export const UPGRADE_PASSWORD_PROTECT_PAYLOAD = {
  title: 'Upgrade for Password Protection',
  desc: 'Make your link private by adding a layer of security',
  gif: '/assets/img/gifs/password-protection.gif',
  cta: 'Enable Protection'
}

export const UPGRADE_CAPTURE_EMAILS_PAYLOAD = {
  title: 'Upgrade to Capture Emails',
  desc: 'Capture potential leads by requiring visitors to enter their email address',
  gif: '/assets/img/gifs/email-capture.gif',
  cta: 'Capture Emails'
}

export const UPGRADE_PRESENTATION_PAYLOAD = {
  title: 'Upgrade for Presentation Mode',
  desc: 'Displays PDF as a slideshow',
  gif: '/assets/img/gifs/presentation-mode.gif',
  cta: 'Enter Presentation Mode'
}

export const UPGRADE_EDIT_CODE_PAYLOAD = {
  title: 'Upgrade to Edit Code',
  desc: "Unlock full control by editing your site's HTML, CSS, and JavaScript directly.",
  gif: '/assets/img/gifs/edit-code.gif',
  cta: 'Edit Code'
}

export const UPGRADE_ANALYTICS_PAYLOAD = {
  title: 'Upgrade to view Analytics',
  desc: 'See who viewed your website',
  gif: '/assets/img/gifs/analytics.gif',
  cta: 'View Analytics'
}

export const UPGRADE_TRACKLINKS_PAYLOAD = {
  title: 'Create tracked links',
  desc: 'Generate a unique link for each recipient, track opens and clicks, and know exactly when your content is viewed.',
  gif: '/assets/img/gifs/tracked-links.gif',
  cta: 'Create tracked link'
}

export const UPGRADE_SLIDE_IN_PAYLOAD = {
  title: 'Upgrade to add a promotional slide-in',
  desc: 'Convert more visitors with compelling calls-to-action that drive engagement.',
  gif: '/assets/img/gifs/slide-in.gif',
  cta: 'Upgrade now'
}

export const SHOW_TRACKED_LINK_CREATE_MODAL = 'SHOW_TRACKED_LINK_CREATE_MODAL'
export const showTrackedLinkCreateModal = (payload) => ({
  type: SHOW_TRACKED_LINK_CREATE_MODAL,
  payload
})

export const HIDE_TRACKED_LINK_CREATE_MODAL = 'HIDE_TRACKED_LINK_CREATE_MODAL'
export const hideTrackedLinkCreateModal = () => ({
  type: HIDE_TRACKED_LINK_CREATE_MODAL
})

export const SHOW_ANALYTICS_MODAL = 'SHOW_ANALYTICS_MODAL'
export const showAnalyticsModal = (payload) => ({
  type: SHOW_ANALYTICS_MODAL,
  payload
})

export const HIDE_ANALYTICS_MODAL = 'HIDE_ANALYTICS_MODAL'
export const hideAnalyticsModal = () => ({
  type: HIDE_ANALYTICS_MODAL
})
